const styles = () => ({
  form: {
    padding: '0 0',
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
  },

  searchBuilderContainer: {
    background: 'rgb(250, 251, 252)',
    borderTop: '1px solid rgba(89, 97, 104, 0.15)',
    flex: '1 0 auto',
    padding: '40px 40px 18rem',
  },
});

export default styles;
